define('OutSystems/ClientRuntime/SystemStructures',["require", "exports", "tslib", "./DataTypes"], function (require, exports, tslib_1, DataTypes_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.AttachmentRecordList = exports.AttachmentList = exports.AttachmentRecord = exports.AttachmentRec = void 0;
    var AttachmentRec = (function (_super) {
        tslib_1.__extends(AttachmentRec, _super);
        function AttachmentRec(defaults, cache) {
            return _super.call(this, defaults, cache) || this;
        }
        AttachmentRec.attributesToDeclare = function () {
            return [
                this.attr("FileName", "fileNameAttr", "FileName", false, false, DataTypes_1.DataTypes.Text, function () {
                    return (0, DataTypes_1.defaultForType)(DataTypes_1.DataTypes.Text);
                }),
                this.attr("FileContent", "fileContentAttr", "FileContent", false, false, DataTypes_1.DataTypes.BinaryData, function () {
                    return (0, DataTypes_1.defaultForType)(DataTypes_1.DataTypes.BinaryData);
                }),
                this.attr("MimeType", "mimeTypeAttr", "MimeType", false, false, DataTypes_1.DataTypes.Text, function () {
                    return (0, DataTypes_1.defaultForType)(DataTypes_1.DataTypes.Text);
                }),
            ].concat(_super.attributesToDeclare.call(this));
        };
        AttachmentRec = tslib_1.__decorate([
            (0, DataTypes_1.RecordWithStaticConstructor)()
        ], AttachmentRec);
        return AttachmentRec;
    }(DataTypes_1.GenericRecord));
    exports.AttachmentRec = AttachmentRec;
    var AttachmentRecord = (function (_super) {
        tslib_1.__extends(AttachmentRecord, _super);
        function AttachmentRecord(defaults, cache) {
            return _super.call(this, defaults, cache) || this;
        }
        AttachmentRecord_1 = AttachmentRecord;
        AttachmentRecord.attributesToDeclare = function () {
            return [
                this.attr("Attachment", "attachmentAttr", "Attachment", false, false, DataTypes_1.DataTypes.Record, function () { return DataTypes_1.ImmutableBase.getData(new AttachmentRec()); }, AttachmentRec),
            ].concat(DataTypes_1.GenericRecord.attributesToDeclare());
        };
        var AttachmentRecord_1;
        AttachmentRecord._isAnonymousRecord = true;
        AttachmentRecord.fromStructure = function (str) {
            return new AttachmentRecord_1(new AttachmentRecord_1.RecordClass({
                attachmentAttr: DataTypes_1.ImmutableBase.getData(str),
            }));
        };
        AttachmentRecord = AttachmentRecord_1 = tslib_1.__decorate([
            (0, DataTypes_1.RecordWithStaticConstructor)()
        ], AttachmentRecord);
        return AttachmentRecord;
    }(DataTypes_1.GenericRecord));
    exports.AttachmentRecord = AttachmentRecord;
    var AttachmentList = (function (_super) {
        tslib_1.__extends(AttachmentList, _super);
        function AttachmentList(defaults) {
            return _super.call(this, defaults) || this;
        }
        AttachmentList.itemType = AttachmentRec;
        return AttachmentList;
    }(DataTypes_1.GenericRecordList));
    exports.AttachmentList = AttachmentList;
    var AttachmentRecordList = (function (_super) {
        tslib_1.__extends(AttachmentRecordList, _super);
        function AttachmentRecordList(defaults) {
            return _super.call(this, defaults) || this;
        }
        AttachmentRecordList.itemType = AttachmentRecord;
        return AttachmentRecordList;
    }(DataTypes_1.GenericRecordList));
    exports.AttachmentRecordList = AttachmentRecordList;
});
//# sourceMappingURL=SystemStructures.js.map;
